import { connectStateResults } from 'react-instantsearch-dom';
import { keyframes } from '@emotion/react';
import React from 'react';
import RowSet from '../primitives/grid/row-set';
import { StyledIconButtonColored } from '../primitives/styled-icon-button';
// import ChevronLeft from '../../images/chevron-left.svg';
import ColSet from '../primitives/grid/col-set';
// import ChevronRight from '../../images/chevron-right.svg';

const SearchSkeletonItem = () => {
    const anim = keyframes`
      0% {
        background-color: hsl(200, 20%, 80%);
      }
      100% {
        background-color: hsl(200, 20%, 95%);
      }
    `;

    return (
        <div
            css={{
                borderRadius: '12px',
                width: '100%',
                minHeight: '200px',
                animation: `${anim} 1s linear infinite alternate`,
            }}
        />
    );
};

const SearchSkeletonPagination = () => {
    const anim = keyframes`
      0% {
        background-color: hsl(200, 20%, 80%);
      }
      100% {
        background-color: hsl(200, 20%, 95%);
      }
    `;

    return (
        <div
            css={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                paddingTop: '39px',
                paddingBottom: '39px',
                '@media (max-width: 767px)': {
                    paddingTop: '39px',
                },
            }}
        >
            <StyledIconButtonColored
                css={{
                    width: '51px',
                    height: '51px',
                    display: 'flex',
                    alignItems: 'center',
                    borderWidth: '1px',
                    borderRadius: '500px',
                    justifyContent: 'center',
                    animation: `${anim} 1s linear infinite alternate`,
                    '@media (max-width: 767px)': {
                        width: '38px',
                        height: '38px',
                    },
                }}
            />
            <ColSet breakpoints={{ dt: { between: 18 }, mb: { between: 10 } }} css={{ width: 'unset' }}>
                {new Array(3).fill(null).map((_, index) => {
                    const page = index + 1;
                    return (
                        <StyledIconButtonColored
                            key={index}
                            css={{
                                width: '51px',
                                height: '51px',
                                display: 'flex',
                                minWidth: '52px',
                                minHeight: '52px',
                                alignItems: 'center',
                                borderRadius: '500px',
                                justifyContent: 'center',
                                animation: `${anim} 1s linear infinite alternate`,
                                color: 'var(--color-blue-mittelblau)',
                                '@media (max-width: 767px)': {
                                    width: '38px',
                                    height: '38px',
                                    minWidth: '38px',
                                    minHeight: '38px',
                                },
                            }}
                        />
                    );
                })}
            </ColSet>
            <StyledIconButtonColored
                css={{
                    width: '51px',
                    height: '51px',
                    display: 'flex',
                    alignItems: 'center',
                    animation: `${anim} 1s linear infinite alternate`,
                    borderWidth: '1px',
                    borderRadius: '500px',
                    justifyContent: 'center',
                    '@media (max-width: 767px)': {
                        width: '38px',
                        height: '38px',
                    },
                }}
            />
        </div>
    );
};

const SearchSkeleton = connectStateResults(({ isSearchStalled }) => (
    <>
        <SearchSkeletonPagination />
        <RowSet breakpoints={{ dt: { between: 20 } }}>{isSearchStalled && Array.from({ length: 4 }, _ => <SearchSkeletonItem />)}</RowSet>
        <SearchSkeletonPagination />
    </>
));

export default SearchSkeleton;
